import getApplicationConfig from './getApplicationConfig';
import getLocale from './getLocale';
import getServicesConfig from './getServicesConfig';
import getUberToken from './getUberToken';

export default (state) => {
    const { brandId } = getApplicationConfig(state);
    const { country, language } = getLocale(state);
    const uberToken = getUberToken(state);
    const { commerce } = getServicesConfig(state);

    return {
        brandId,
        country,
        language,
        uberToken,
        ...commerce,
    };
};
